module.exports = __webpack_public_path__ + "advisory-8c397925/yaroslav-olieinikov-cf4a15ba29f70a6b835a36c92058c494.jpg";